import type { ContractField } from '../../../types';

/**
 * Signer colour coding, shared by the field designer and the preview.
 *
 * These used to live only inside PdfFieldDesigner, so the preview had no way to
 * colour a field the way the designer had just drawn it. Anything that renders a
 * placed field reads them from here.
 */
export const SIGNER_TYPES = [
  { id: 'customer', label: 'Customer', color: '#2196F3' },
  { id: 'sales_rep', label: 'Sales Rep', color: '#4CAF50' },
  { id: 'manager', label: 'Manager', color: '#FF9800' },
] as const;

const DEFAULT_SIGNER_COLOR = '#2196F3';

export const getSignerColor = (signer?: string): string =>
  SIGNER_TYPES.find((type) => type.id === signer)?.color ?? DEFAULT_SIGNER_COLOR;

export const getSignerLabel = (signer?: string): string =>
  SIGNER_TYPES.find((type) => type.id === signer)?.label ?? 'Signer';

const FIELD_TYPE_LABELS: Record<string, string> = {
  signature: 'Signature',
  initial: 'Initial',
  text: 'Text',
  date: 'Date',
  checkbox: 'Checkbox',
  radio: 'Radio',
  dropdown: 'Dropdown',
};

export const getFieldTypeLabel = (field: Pick<ContractField, 'type'>): string =>
  FIELD_TYPE_LABELS[field.type] ?? field.type;

/** True when the signer has supplied something for this field. */
export const hasFieldValue = (value: unknown): boolean =>
  value !== undefined && value !== null && value !== '' && value !== false;
